import { memo, useState } from "react";

import { Popover } from "antd";
import { useChartsContext } from "contexts";

import { useChartEntities } from "hooks/charts";

import SlopeLines from "components/icons/SlopeLines";

import ToolbarButton from "../../../base/ToolbarButton";
import SlopeStyleSelector from "./SlopeStyleSelector";

const SlopeLinesToggle = () => {
  const [visible, setVisible] = useState(false);
  const isDisabled = false;
  const { id } = useChartsContext();
  const { quarterSlope, unitSlope, halfSlope } = useChartEntities(id);
  const isEnabled = quarterSlope.enabled || unitSlope.enabled || halfSlope.enabled;
  const isActive = quarterSlope.active || unitSlope.active || halfSlope.active;

  if (!isEnabled) {
    return null;
  }

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      open={visible}
      onOpenChange={(v) => setVisible(v)}
      content={<SlopeStyleSelector />}>
      <ToolbarButton
        active={isActive}
        data-testid="slopelines-toggle"
        icon={<SlopeLines />}
        overflowLabel={"Slope Line"}
        tooltipText={"Show Slope Lines"}
        onToggle={null}
        disabled={isDisabled}
      />
    </Popover>
  );
};

export default memo(SlopeLinesToggle);
